#import "../fragments/entity-related-email-addresses-fragment.graphql"

query GetRelatedEmailAddresses($id: ID!) {
    coreEntity(id: $id) {
        ...EntityRelatedEmailAddresses
    }
}
